import * as React from 'react';
import { SVGProps } from 'react';

const IconLogicalElementSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 2H4v2H1v2h3v4H1v2h3v2h2a6.002 6.002 0 0 0 5.917-5H15V7h-3.083A6.002 6.002 0 0 0 6 2z" />
  </svg>
);
export default IconLogicalElementSizeS;
